<template>
    <van-swipe class="swipe-box" :autoplay="autoplay" indicator-color="#4D90FF" @change="changeFn">
        <van-swipe-item v-for="(item, index) in swipeArr" :key="'swipeArr' + index">
            <div class="video-box">
                <template v-if="!item.isPlay">
                    <img class="icon" :src="item.img" :alt="`${item.imgText1}；${item.imgText2}；${item.imgText3}`">
                    <div class="img-text-box" :class="{ 'l': index === 2 }">
                        <div class="t-1">{{ item.imgText1 }}</div>
                        <div class="t-2">{{ item.imgText2 }}</div>
                        <div class="t-3">{{ item.imgText3 }}</div>
                    </div>
                    <div class="video-mask" v-if="item.mp4" @click="playFn(item, index)">
                        <img class="play" src="@/assets/H5Public/play.png" alt="/">
                    </div>
                </template>
                <video class="video" :ref="`myVideo_${index}`" controls v-show="item.mp4 && item.isPlay"
                    @play="handlePlayFn" @pause="stopFn" @ended="stopFn">
                    <source :src="item.mp4" type="video/mp4">
                </video>
            </div>
            <div class="con" :class="introHeight">
                <div class="tit flex-box">{{ item.tit }}</div>
                <div class="titP1" v-if="item.titP1">{{ item.titP1 }}</div>
                <div class="titP2" v-if="item.titP2">{{ item.titP2 }}</div>
                <div class="intro" v-html="item.intro"></div>
            </div>
        </van-swipe-item>
    </van-swipe>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);

export default {
    props: {
        swipeArr: {
            type: Array,
            default: () => []
        },
        introHeight: {
            type: String,
            default: "middle"
        }
    },
    data() {
        return {
            autoplay: 4000,//自动轮播间隔，单位为 ms
            videoActive: null,
            itemActive: null,
        }
    },
    created() {
    },
    mounted() {

    },
    methods: {
        playFn(item, index) {
            this.videoActive = this.$refs[`myVideo_${index}`][0];
            this.videoActive.play();
            item.isPlay = true;
            this.itemActive = item;
            this.autoplay = 9999999
        },
        changeFn() {
            this.autoplay = 4000;
            this.videoActive && this.videoActive.pause();
        },
        handlePlayFn() {
            this.autoplay = 9999999;
        },
        stopFn() {
            this.itemActive.isPlay = false
        }
    },
};
</script>

<style lang="less" scoped>
@import "../../style/mixin.less";

.swipe-box {
    padding-bottom: .convert(40) [ @vw];

    /deep/ .van-swipe__indicators {
        bottom: .convert(20) [ @vw];

        .van-swipe__indicator {
            background-color: #4D90FF;
            width: .convert(8) [ @vw];
            height: .convert(8) [ @vw];
        }
    }

    .video-box {
        width: .convert(327) [ @vw];
        height: .convert(160) [ @vw];
        position: relative;

        .icon,
        .video,
        .video-mask {
            width: 100%;
            height: 100%;
        }


        .img-text-box {
            position: absolute;
            top: .convert(97) [ @vw];
            color: #fff;
            left: .convert(60) [ @vw];

            &.l {
                left: .convert(30) [ @vw];
            }

            .t-3 {
                color: #4D90FF;
                font-size: .convert(14) [ @vw];
                text-align: center;
            }
        }

        .video-mask {
            position: absolute;
            top: 0;
            left: 0;

            .play {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                width: .convert(36) [ @vw];
                height: .convert(36) [ @vw];
            }
        }
    }


    .con {
        background-color: #F1F9FF;
        padding: 0 .convert(11) [ @vw];
        height: .convert(180) [ @vw];

        &.min {
            height: .convert(150) [ @vw];
        }

        &.max {
            height: .convert(260) [ @vw];
        }

        &.max2 {
            height: .convert(330) [ @vw];
        }

        .tit {
            height: .convert(54) [ @vw];
            padding-top: .convert(14) [ @vw];
            justify-content: start;
            color: #007DE9;
        }

        .titP1,
        .titP2 {
            font-size: .convert(13) [ @vw];
            line-height: .convert(16) [ @vw];
        }

        .titP2 {
            margin-bottom: .convert(10) [ @vw];
            font-weight: 700;
        }

        .intro {
            font-size: .convert(13) [ @vw];
            color: #666666;
            line-height: .convert(18) [ @vw];
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/components/H5/videoSwipe.vue